import { IModel } from "@/@types/models/model";

import { coreFields} from "./helpers/coreFields";

const Kat: IModel = {
  title: "Katovi",
  apiPath: "operations/objekti/{objekti_id}/katovi",
  forms : {
    "default": {
      fields: [ "id", "objekti_id", "broj_kata", "broj_dijelova", "pre_pb", "kat_tip_id"]
    },
    "insert": {
      fields: [ "objekti_id", "broj_kata", "pre_pb"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "broj_kata", "broj_dijelova", "details_namjena_pb", "details_namjena_pn", "sum_pre_pb", "kat_tip_id"],
      hidden: ["id"]
    },
    "radni_sastanci": {
      fields: ["broj_kata", "stambeno", "poslovno", "garazno", "pomocno", "balkoni", "javno", "zemljiste", "neizgradeno", "bazen", "ostalo", "ukupna_povrsina"],
    }
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    coreFields.modified_on,
    {
      title: "Object ID",
      source: "objekti_id",
      ttoken: "common.objectid",
      type: "numeric",
      validation: {
        required: true
      },
      readonly: true
    },
    {
      title: "Broj kata",
      source: "broj_kata",
      ttoken: "katovi.broj_kata",
      type: "text",
      validation: {
        required: true,
        maxLength: 20
      },
      readonly: true,
    },
    {
      title: "Dijelovi",
      source: "details_namjena_pb",
      ttoken: "katovi.namjena_dijelova_pb",
      type: "array",
      sort: false,
      readonly: true,
    },
    {
      title: "Dijelovi",
      source: "details_namjena_pn",
      ttoken: "katovi.namjena_dijelova_pn",
      type: "array",
      sort: false,
      readonly: true,
    },
    {
      title: "Broj dijelova",
      source: "broj_dijelova",
      ttoken: "common.broj_dijelova",
      type: "numeric",
      readonly: true,
      calculated: true
    },
    {
      title: "Pre PB",
      source: "pre_pb",
      ttoken: "common.pre_pb",
      type: "numeric",
      readonly: true,
      calculated: true
    },
    {
      title: "Sum Pre PB",
      source: "sum_pre_pb",
      ttoken: "common.pre_pb",
      type: "numeric",
      readonly: true,
      calculated: true
    },
    {
      title: "Sum Pre PN",
      source: "sum_pre_pn",
      ttoken: "common.pre_pn",
      type: "numeric",
      readonly: true,
      calculated: true
    },
    {
      title: "Namjena ID",
      source: "kat_tip_id",
      ttoken: "katovi.kat_tip_id",
      type: "buttonGroup",
      items: {
        labels: ['P', 'S', 'T'],
        values: [1, 2, 3]
      },
      rowWidth: 3
    },
    {
      title: "Stambeno",
      source: "stambeno",
      ttoken: "katovi.stambeno",
      type: "numeric"
    },
    {
      title: "Poslovno",
      source: "poslovno",
      ttoken: "katovi.poslovno",
      type: "numeric"
    },
    {
      title: "Garazno",
      source: "garazno",
      ttoken: "katovi.garazno",
      type: "numeric"
    },
    {
      title: "Pomocno",
      source: "pomocno",
      ttoken: "katovi.pomocno",
      type: "numeric"
    },
    {
      title: "Balkoni/Terase",
      source: "balkoni",
      ttoken: "katovi.balkoni",
      type: "numeric"
    },
    {
      title: "Zemljiste u funkciji objekta",
      source: "zemljiste",
      ttoken: "katovi.zemljiste",
      type: "numeric"
    },
    {
      title: "Javno",
      source: "javno",
      ttoken: "katovi.javno",
      type: "numeric"
    },
    {
      title: "Bazen",
      source: "bazen",
      ttoken: "katovi.bazen",
      type: "numeric"
    },
    {
      title: "Neizgradeno gradevinsko zemljiste",
      source: "neizgradeno",
      ttoken: "katovi.neizgradeno",
      type: "numeric"
    },
    {
      title: "Ostalo",
      source: "ostalo",
      ttoken: "katovi.ostalo",
      type: "numeric"
    },
    {
      title: "Stambeno",
      source: "stambeno",
      ttoken: "katovi.stambeno",
      type: "numeric"
    },
    {
      title: "Ukupna povrsina",
      source: "ukupna_povrsina",
      ttoken: "common.pre_pb",
      type: "numeric"
    }
  ]
}

export default Kat;
